import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { LoadMapData } from 'src/app/core/state/_actions/report.actions';
import { MapReportData } from 'src/app/core/state/_models/report.models';

@Component({
  selector: 'app-filter-map',
  templateUrl: './filter-map.component.html',
  styleUrls: ['./filter-map.component.scss']
})
export class FilterMapComponent implements OnInit {
  @Input('isMapInteractive') isMapInteractive: boolean = false;
  @Input('isEmbeddedReport') isEmbeddedReport: boolean = false;
  @Input('fromDashboard') fromDashboard: boolean = false;
  @Input('filterFieldOptions') filterFieldOptions: any;
  @Input('mapReportData') mapReportData:any;
  @Input('seriesData') seriesData:any;
  @Input('geoJSONData') geoJSONData:any;
  @Input('tableId') tableId:any;
  @Input('reportId') reportId:any;
  @Input('referenceFieldKey') referenceFieldKey:string = '';
  @Input('lookupfield') lookupfield:any;
  @Input('markerColorField') markerColorField:any;
  @Input('totalRecords') totalRecords:number = 0;
  @Input('filteredRecord') filteredRecord:number = 0;
  @Input('isLimitExceed') isLimitExceed:boolean = false;
  @Input('enableAccessibility') enableAccessibility:boolean = false;
  @Output() disableFilter = new EventEmitter<void>();
  @Output() applyLayer = new EventEmitter<string>();
  @Output() resetMapData = new EventEmitter<string>();

  filterSearch:string = '';
  filterData:Array<string> = [];
  filter1Options: any;
  filter2Options: any;
  filter3Options: any;
  mapTemplates: any = [];
  form!: UntypedFormGroup

  constructor(
    private store:Store,
    private fb: UntypedFormBuilder
  ) { }

  ngOnInit(): void {
    if(this.isMapInteractive){
      this.filter1Options = this.seriesData?.find((series:any) => series.Key === this.mapReportData?.SeriesField1?.Key)?.Value?.map((fieldData:string) => {
        return {
          label:fieldData,
          value:fieldData
        }
      });
      this.filter2Options = this.seriesData?.find((series:any) => series.Key === this.mapReportData?.SeriesField2?.Key)?.Value?.map((fieldData:string) => {
        return {
          label:fieldData,
          value:fieldData
        }
      });
      this.filter3Options = this.seriesData?.find((series:any) => series.Key === this.mapReportData?.SeriesField3?.Key)?.Value?.map((fieldData:string) => {
        return {
          label:fieldData,
          value:fieldData
        }
      });

      this.form = this.fb.group({
        Filter1:[null],
        Filter2:[null],
        Filter3:[null],
        Filter12:[null],
        Filter22:[null],
        Filter32:[null],
        Layer:[null],
      });
      if(this.geoJSONData?.length && this.mapReportData?.MapTemplates){
        this.mapTemplates = [];
        this.geoJSONData?.forEach((geoJson:any) => {
          this.mapTemplates.push({
            label:this.mapReportData?.MapTemplates?.find((template:any) => template.TemplateKey === geoJson.Key).Template.Name,
            value:geoJson?.Value
          })
        })
      }

    }
  }

  getFilterFieldData(searchValue:string = ''){
    if(!searchValue) return this.filterFieldOptions;
    else return this.filterFieldOptions.filter((filterData:any) => filterData.toLowerCase().includes(searchValue.toLowerCase()));
  }

  filtermapData(value:any){
    if(this.filterData.find((data:any) => data == value)){
      this.filterData = this.filterData.filter((data:any) => data != value);
    } else {
      this.filterData.push(value);
    }
  }

  isFieldInFilterData(name:any){
    return this.filterData.find((data:any)=> data == name);
  }

  applyFilters(){
    let filterConditionGroup:any;
    if(this.isMapInteractive){
      let conditions:any = [];
      filterConditionGroup = {
        Type: 'any',
        Conditions: []
      };
      if(this.form.value?.Filter1?.length && Array.isArray(this.form.value?.Filter1)){
        conditions.push({
          Key:this.mapReportData?.SeriesField1.Key,
          Value:this.form.value.Filter1?.map((filter:any) => this.mapReportData?.SeriesField1?.FieldType === 'TINYINT(1)' ? (filter === 'True' ? 1:0) : filter)
        })
      } else if( this.form.value?.Filter1 && (this.mapReportData.SeriesField1?.FieldType === 'INT' || this.mapReportData.SeriesField1?.FieldType === 'DOUBLE' || this.mapReportData.SeriesField1?.FieldType === 'DECIMAL(20,2)' )) {
        filterConditionGroup.Conditions.push({
          ConditionField: { Key: this.mapReportData.SeriesField1.Key},
          OperationType: 'less than or equal to',
          Value: this.form.value.Filter1
        })
      } else if(this.mapReportData.SeriesField1?.FieldType === 'DATE' || this.mapReportData.SeriesField1?.FieldType === 'DATETIME'){
        if(this.form.value?.Filter1 && this.form.value?.Filter12){
          filterConditionGroup.Conditions.push({
            ConditionField: { Key: this.mapReportData.SeriesField1.Key},
            OperationType: 'between_date',
            Date:this.form.value.Filter1,
            Date2:this.form.value.Filter12,
            Value: `${this.form.value.Filter1},${ this.form.value.Filter12}`
          })
        } else if(this.form.value?.Filter1 && !this.form.value?.Filter12){
          filterConditionGroup.Conditions.push({
            ConditionField: { Key: this.mapReportData.SeriesField1.Key},
            OperationType: 'on_or_after_date',
            Value: this.form.value.Filter1
          })
        } else if(this.form.value?.Filter12 && !this.form.value?.Filter1){
          filterConditionGroup.Conditions.push({
            ConditionField: { Key: this.mapReportData.SeriesField1.Key},
            OperationType: 'on_or_before_date',
            Value: this.form.value.Filter12
          })
        }
      }
      if(this.form.value?.Filter2?.length && Array.isArray(this.form.value?.Filter2)){
        conditions.push({
          Key:this.mapReportData?.SeriesField2.Key,
          Value:this.form.value.Filter2?.map((filter:any) => this.mapReportData?.SeriesField2?.FieldType === 'TINYINT(1)' ? (filter === 'True' ? 1:0) : filter)
        })
      } else if( this.form.value?.Filter2 && (this.mapReportData.SeriesField2?.FieldType === 'INT' || this.mapReportData.SeriesField2?.FieldType === 'DOUBLE' || this.mapReportData.SeriesField2?.FieldType === 'DECIMAL(20,2)' )) {
        filterConditionGroup.Conditions.push({
          ConditionField: { Key: this.mapReportData.SeriesField2.Key},
          OperationType: 'less than or equal to',
          Value: this.form.value.Filter2
        })
      } else if(this.mapReportData.SeriesField2?.FieldType === 'DATE' || this.mapReportData.SeriesField2?.FieldType === 'DATETIME'){
        if(this.form.value?.Filter2 && this.form.value?.Filter22){
          filterConditionGroup.Conditions.push({
            ConditionField: { Key: this.mapReportData.SeriesField2.Key},
            OperationType: 'between_date',
            Date:this.form.value.Filter2,
            Date2:this.form.value.Filter22,
            Value: `${this.form.value.Filter2},${ this.form.value.Filter22}`
          })
        } else if(this.form.value?.Filter2 && !this.form.value?.Filter22){
          filterConditionGroup.Conditions.push({
            ConditionField: { Key: this.mapReportData.SeriesField2.Key},
            OperationType: 'on_or_after_date',
            Value: this.form.value.Filter2
          })
        } else if(this.form.value?.Filter22 && !this.form.value?.Filter2){
          filterConditionGroup.Conditions.push({
            ConditionField: { Key: this.mapReportData.SeriesField2.Key},
            OperationType: 'on_or_before_date',
            Value: this.form.value.Filter22
          })
        }
      }

      if(this.form.value?.Filter3?.length && Array.isArray(this.form.value?.Filter3)){
        conditions.push({
          Key:this.mapReportData?.SeriesField3.Key,
          Value:this.form.value.Filter3?.map((filter:any) => this.mapReportData?.SeriesField3?.FieldType === 'TINYINT(1)' ? (filter === 'True' ? 1:0) : filter)
        })
      } else if( this.form.value?.Filter3 && (this.mapReportData.SeriesField3?.FieldType === 'INT' || this.mapReportData.SeriesField3?.FieldType === 'DOUBLE' || this.mapReportData.SeriesField3?.FieldType === 'DECIMAL(20,2)' )) {
        filterConditionGroup.Conditions.push({
          ConditionField: { Key: this.mapReportData.SeriesField3.Key},
          OperationType: 'less than or equal to',
          Value: this.form.value.Filter3
        })
      } else if(this.mapReportData.SeriesField3?.FieldType === 'DATE' || this.mapReportData.SeriesField3?.FieldType === 'DATETIME'){
        if(this.form.value?.Filter3 && this.form.value?.Filter32){
          filterConditionGroup.Conditions.push({
            ConditionField: { Key: this.mapReportData.SeriesField3.Key},
            OperationType: 'between_date',
            Date:this.form.value.Filter3,
            Date2:this.form.value.Filter32,
            Value: `${this.form.value.Filter3},${ this.form.value.Filter32}`
          })
        } else if(this.form.value?.Filter3 && !this.form.value?.Filter32){
          filterConditionGroup.Conditions.push({
            ConditionField: { Key: this.mapReportData.SeriesField3.Key},
            OperationType: 'on_or_after_date',
            Value: this.form.value.Filter3
          })
        } else if(this.form.value?.Filter32 && !this.form.value?.Filter3){
          filterConditionGroup.Conditions.push({
            ConditionField: { Key: this.mapReportData.SeriesField3.Key},
            OperationType: 'on_or_before_date',
            Value: this.form.value.Filter32
          })
        }
      }

      if(conditions.length){
        conditions.forEach((condition: { Value: any[]; Key: any; }) => {
          condition.Value.forEach((value: any)=>{
            filterConditionGroup.Conditions.push({
              ConditionField: {Key: condition.Key},
              OperationType:'is equal',
              Value:value
            })
          })
        })
      }
    } else {
      filterConditionGroup = {
        Type: 'any',
        Conditions: this.filterData.map(filter => {
          return {
            ConditionField: {Key: this.mapReportData?.SeriesField1.Key},
            OperationType:'is equal',
            Value:this.mapReportData?.SeriesField1?.FieldType === 'TINYINT(1)' ? (filter === 'True' ? 1:0) : filter
          }
        })
      };
    }
    if (this.isEmbeddedReport) {
      this.dispatchFormOpration(filterConditionGroup.Conditions?.length ? [filterConditionGroup,this.getEmbeddedCondition()]: [this.getEmbeddedCondition()]);
    } else {
      this.dispatchFormOpration(filterConditionGroup?.Conditions?.length ? [filterConditionGroup]: null);
    }
    this.disableFilter.emit();
  }

  dispatchFormOpration(conditionGroup:any){
    this.store.dispatch(
      new LoadMapData(this.tableId, this.reportId, this.fromDashboard,false,conditionGroup)
    );
  }

  getEmbeddedCondition(){
    return {
      Type: 'all',
      Conditions: [
        {
          ConditionField: { Key:this.referenceFieldKey, IsRelation:true},
          OperationType:'is equal',
          Value:this.lookupfield
        }
      ]
    }
  }

  onLayerSelection(){
    if(this.form.value.Layer){
      this.applyLayer.emit(window.atob(this.form.value.Layer))
    }
  }

  resetMap(){
    this.form.reset();
    this.resetMapData.emit();
  }

  getFilterTitle(){
    if(this.totalRecords !== this.filteredRecord){
      return `Showing ${ this.filteredRecord } of ${ this.totalRecords } records`;
    }
    return `Showing all ${ this.totalRecords } records`;
  }

  private colorMap = new Map<string | number, string>(); // Cache for colors

  private isValidColor(str: string): boolean {
    const s = new Option().style;
    s.color = str;
    return s.color !== '';
  }

  getColorForValue(value: any): string {
    if(this.isLimitExceed) return 'blue';
    if (typeof value === 'string' && this.isValidColor(value)) {
      return value;
    }

    if (value === undefined || value === null || value === '') {
      return 'blue'; // Light gray as default
    }

    if (this.colorMap.has(value)) {
      return this.colorMap.get(value)!;
    }

    // List of predefined colors
    const predefinedColors = [
      '#4B3FFF',
      '#5069FF',
      '#7F8CA0',
      '#F86A0B',
      '#000000',
      '#DCE6F4',
      '#31414E'
    ];

    const valueStr = String(value);
    const hash = this.hashCode(valueStr);
    const hueOffset = Math.abs(hash) % predefinedColors.length;

    // Get hue from predefined colors
    const hue = this.getHueFromColor(predefinedColors[hueOffset]);
    const saturation = 70 + Math.abs(hash) % 30; // Adjust saturation
    const lightness = 50 + Math.abs(hash) % 20; // Adjust lightness
    const color = `hsl(${hue}, ${saturation}%, ${lightness}%)`;

    this.colorMap.set(value, color);

    return color;
  }

  hashCode(str: string): number {
    let hash = 0;
    if (str.length === 0) {
      return hash;
    }
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
  }

  getHueFromColor(color: string): number {
    // Convert hex to RGB
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    color = color.replace(shorthandRegex, (m, r, g, b) => {
      return r + r + g + g + b + b;
    });
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
    if (!result) {
      throw new Error('Invalid color format');
    }
    let r = parseInt(result[1], 16) / 255;
    let g = parseInt(result[2], 16) / 255;
    let b = parseInt(result[3], 16) / 255;

    // Find max and min values to get hue
    let max = Math.max(r, g, b);
    let min = Math.min(r, g, b);
    let hue = 0;

    if (max === r) {
      hue = (g - b) / (max - min);
    } else if (max === g) {
      hue = 2 + (b - r) / (max - min);
    } else {
      hue = 4 + (r - g) / (max - min);
    }

    hue *= 60; // Convert to degrees
    if (hue < 0) hue += 360; // Make sure hue is positive

    return hue;
  }

  getMinData(seriesField:string = ''){
    return Number(Math.min(...this.seriesData?.find((series:any) => series.Key === this.mapReportData?.[seriesField].Key)?.Value || []))
  }

  getMaxData(seriesField:string = ''){
    return Number(Math.max(...this.seriesData?.find((series:any) => series.Key === this.mapReportData?.[seriesField].Key)?.Value || []))
  }

  ngDestroy(){
    this.mapTemplates = [];
  }
}
